module.exports = __webpack_public_path__ + "static/media/s_30.e3c32f25.mp3";